import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

export default function Addon(props) {

    const designer = useDesigner();

    return <>
        <Tooltip title="缩放到 1:1 显示" placement="bottom">
            <Button
                onClick={e => designer.flyToResolution(1)}
            >
                <Application.SystemSvgIcon type="xiangdengbili" />
            </Button>
        </Tooltip>
    </>
}